import { Component, DOCUMENT, inject } from '@angular/core';
import { Toast } from 'primeng/toast';
import { ConfirmDialogComponent, LoadingIndicatorComponent, MainLayoutComponent } from '#components';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService, AnalyticsService } from '#services';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [Toast, LoadingIndicatorComponent, ConfirmDialogComponent, MainLayoutComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',

  standalone: true,
})
export class App {
  private _translationService = inject(TranslateService);
  private _router = inject(Router);
  private _analyticsService = inject(AnalyticsService);
  private readonly document = inject(DOCUMENT);

  authService = inject(AuthService);

  constructor() {
    this._translationService.onLangChange.pipe(takeUntilDestroyed()).subscribe(({ lang }) => {
      this.document.documentElement.setAttribute('lang', lang);
    });

    // Track page views on navigation
    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe((event: NavigationEnd) => {
        this._analyticsService.trackPageView(undefined, event.urlAfterRedirects);
      });
  }
}
